import { render, staticRenderFns } from "./viewLeaderboard.vue?vue&type=template&id=ee4ab3f8&scoped=true&"
import script from "./viewLeaderboard.vue?vue&type=script&lang=js&"
export * from "./viewLeaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4ab3f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
